import { useEffect, useRef, useState } from "react"
import { AccordionRoutesEnum } from "../../../../types/AccordionRoutes"
import { Container, Extratext, Info, Input, InputErrorMessage, Label } from "./CPRinput.style"
import { useStore } from "../../../../store/store"
import { useWindowResize } from "../../../../hooks/useWindowResize"
import Modal from "../../components/Modal";

interface Props {
    id: string, 
    name: string,
    labelText: string,
    extraText?: string,
    placeholder: string,
    autocomplete: string,
    step: AccordionRoutesEnum
    value?: string,
    onChange?: React.ChangeEventHandler<HTMLInputElement>
    onBlur?: React.FocusEventHandler<HTMLInputElement>,
    validated: boolean | undefined,
    errorText?: string
  }
  
  export default function CPRinput({id, name, labelText, extraText, placeholder, autocomplete, value, step, onChange, onBlur, validated = undefined, errorText = ''} : Props) {
    const accordionRoute = useStore.useAccordionRoute();
    const translations = useStore.useTranslations();
    const [showInfo, setShowInfo] = useState(false);
    
    return (
      <>
        <Container>
            <Label htmlFor={id}>{labelText}</Label>
            {/* <Info style={{ cursor: "pointer" }} onClick={() => setShowInfo(true)}>i</Info> */}
            <br/>
            <Input type="text" maxLength={10} id={id} name={name} placeholder={placeholder} autoComplete={autocomplete} validated={validated} value={value} onBlur={onBlur} onChange={e => {
              onChange && onChange(e)
            }}/>
            {extraText && <Extratext>{extraText}</Extratext>}
            {(validated !== undefined && accordionRoute === step && !validated && errorText === '') && (
                <InputErrorMessage>{translations?.informationAboutYouStep.errorCpr}</InputErrorMessage>
            )}
             {(validated !== undefined && accordionRoute === step && !validated && errorText !== '') && (
                <InputErrorMessage>{errorText}</InputErrorMessage>
            )}
        </Container>
        <Modal modalText="Du skal oplyse dit CPR-nummer til Ase, for at du kan få fradrag for dit medlemskab og udbetalt dagpenge, hvis du bliver ledig." modalTexth1="Hvorfor skal du oplyse dit CPR-nummer?" modalBlock={false} showModal={showInfo} onClose={() => setShowInfo(false)} />
      </>
    )
}